/** Convert Retry-After seconds or an HTTP date to a wait duration. */
export function parseRetryAfterMs(value: string | null | undefined, now = Date.now()): number | undefined {
  if (!value?.trim()) return undefined;
  const seconds = Number(value);
  const duration = Number.isFinite(seconds)
    ? seconds * 1000
    : Date.parse(value) - now;
  return Number.isFinite(duration) && duration >= 0
    ? duration
    : undefined;
}

/** A missing header still needs a cooldown, rather than immediate recovery calls. */
export function rateLimitRetryAt(error: unknown, now = Date.now()): number | null {
  if (!error || typeof error !== 'object' || Number((error as { status?: unknown }).status) !== 429) return null;
  const retryAfterMs = (error as { retryAfterMs?: unknown }).retryAfterMs;
  return now + (typeof retryAfterMs === 'number' && Number.isFinite(retryAfterMs)
    ? Math.max(1000, retryAfterMs)
    : 60_000);
}
